import { useTranslation } from 'react-i18next';
import { isInterfaceLanguage } from './languageStorage.js';
import { changeUserLanguage } from './useUserLanguage.js';
import styles from './Preferences.module.css';

export function LanguagePicker({ compteId }: { compteId: string }) {
  const { t, i18n } = useTranslation('regie');
  return (
    <div className={styles.language}>
      <label htmlFor="interface-language">{t('preferences.langue')}</label>
      <select
        id="interface-language"
        value={i18n.resolvedLanguage === 'en' ? 'en' : 'fr'}
        onChange={(event) => {
          if (isInterfaceLanguage(event.target.value)) {
            changeUserLanguage(compteId, event.target.value);
          }
        }}
        aria-describedby="interface-language-description"
      >
        <option value="fr">Français</option>
        <option value="en">English</option>
      </select>
      <p id="interface-language-description">{t('preferences.langueDescription')}</p>
    </div>
  );
}
